import {useEffect, useState} from "react";
import {globalMessageHandler, Rules, ValidationErrors, Validator} from "common";
import {acceptInvitation, AcceptInvitationForm, getInvitationDetails} from "./acceptInvitationAPI";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {selectIdentityStatus} from "../../identitySlice";
import I18n from "i18n-js";

export interface AcceptInvitationFormProps {
  defaultValues?: AcceptInvitationForm;
  onSuccessAccept: Function;
  token: string;
}

export function validateAcceptInvitation(values: AcceptInvitationForm) {
  let rules: Rules = {
    first_name: Validator.rule.string().required(),
    last_name: Validator.rule.string().required(),
    password: Validator.rule.string().required(),
  };

  return Validator.validate(rules, values, "AcceptInvitation");
}

export interface TokenData {
  email: string;
}

export default function useAcceptInvitationForm({defaultValues, onSuccessAccept, token}: AcceptInvitationFormProps) {
  const [item, setItem] = useState<AcceptInvitationForm>(
    defaultValues || ({} as AcceptInvitationForm)
  );
  const [errors, setErrors] = useState<ValidationErrors>({});
  const [tokenData, setTokenData] = useState<TokenData>({} as TokenData);
  const [loading, setLoading] = useState<boolean>(false);

  function onChange(values: AcceptInvitationForm) {
    values.email = tokenData.email;
    setItem(values);
  }

  useEffect(() => {
    if (token !== '') {
      updateEmail();
    }
  }, [token]);

  async function updateEmail() {
    const response = await getInvitationDetails(token);
    if (response.data.success) {
      setTokenData(response.data.data);

      item.email = response.data.data.email;
      setItem(item);
    }
  }

  async function process() {
    setLoading(true);
    const result = validateAcceptInvitation(item);
    setErrors(result.errors);

    if (!result.success) {
      setLoading(false);
      return;
    }

    try {
      const response = await acceptInvitation(item, token);
      const data = response.data;

      setLoading(false);

      if (!data || !data.success) {
        setErrors(response.error.form_errors);
      } else {
        onSuccessAccept();
      }
    } catch (e) {
      setErrors({
        password: "Unknown error",
      })
    }
  }

  return {
    item,
    errors,
    loading,
    process,
    onChange
  };
}